
				var addMethods = require("../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["getCounties","getStates","getCountries"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "7cc22264aa6b7e5ef16a.worker.js", { name: "[hash].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			